(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('editorial-hero')) {
    customElements.define('editorial-hero', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.editorial-hero__slide'));
        this.dots = Array.from(this.querySelectorAll('.editorial-hero__dot'));
        this.index = 0;
        this.timer = null;
        this.visible = true;
        this.touchStart = null;
        this.onClick = (event) => {
          const arrow = event.target.closest('[data-direction]');
          const dot = event.target.closest('[data-index]');
          if (arrow) this.show(this.index + Number(arrow.dataset.direction), true);
          if (dot) this.show(Number(dot.dataset.index), true);
        };
        this.onKeydown = (event) => {
          if (event.target.closest('input, textarea, select')) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
          }
        };
        this.onEnter = () => { if (this.dataset.pauseHover === 'true') this.pause(); };
        this.onLeave = () => this.resume();
        this.onFocusIn = () => this.pause();
        this.onFocusOut = (event) => { if (!this.contains(event.relatedTarget)) this.resume(); };
        this.onVisibility = () => { this.syncVideos(); this.resume(); };
        this.onResize = () => this.syncVideos();
        this.onTouchStart = (event) => { this.touchStart = { x: event.changedTouches[0].clientX, y: event.changedTouches[0].clientY }; };
        this.onTouchEnd = (event) => {
          if (!this.touchStart || this.dataset.swipe !== 'true') return;
          const dx = event.changedTouches[0].clientX - this.touchStart.x;
          const dy = event.changedTouches[0].clientY - this.touchStart.y;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.25) this.show(this.index + (dx < 0 ? 1 : -1), true);
          this.touchStart = null;
        };
        this.onBlockSelect = (event) => {
          const slide = event.target.closest?.('.editorial-hero__slide');
          if (slide && this.contains(slide)) { this.show(this.slides.indexOf(slide)); this.pause(); }
        };
        this.onSectionSelect = (event) => { if (event.target.contains(this)) this.pause(); };
        this.onSectionDeselect = () => this.resume();
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        this.addEventListener('mouseenter', this.onEnter);
        this.addEventListener('mouseleave', this.onLeave);
        this.addEventListener('focusin', this.onFocusIn);
        this.addEventListener('focusout', this.onFocusOut);
        this.addEventListener('touchstart', this.onTouchStart, { passive: true });
        this.addEventListener('touchend', this.onTouchEnd, { passive: true });
        document.addEventListener('visibilitychange', this.onVisibility);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:section:select', this.onSectionSelect);
        document.addEventListener('shopify:section:deselect', this.onSectionDeselect);
        window.addEventListener('resize', this.onResize);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(([entry]) => { this.visible = entry.isIntersecting; this.syncVideos(); this.resume(); }, { threshold: 0.1 });
          this.observer.observe(this);
        }
        this.syncVideos();
        this.resume();
      }

      disconnectedCallback() {
        this.pause();
        this.observer?.disconnect();
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        this.removeEventListener('mouseenter', this.onEnter);
        this.removeEventListener('mouseleave', this.onLeave);
        this.removeEventListener('focusin', this.onFocusIn);
        this.removeEventListener('focusout', this.onFocusOut);
        this.removeEventListener('touchstart', this.onTouchStart);
        this.removeEventListener('touchend', this.onTouchEnd);
        document.removeEventListener('visibilitychange', this.onVisibility);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:section:select', this.onSectionSelect);
        document.removeEventListener('shopify:section:deselect', this.onSectionDeselect);
        window.removeEventListener('resize', this.onResize);
      }

      show(next, manual = false) {
        if (this.slides.length < 2) return;
        if (this.dataset.loop === 'false' && (next < 0 || next >= this.slides.length)) return;
        this.index = (next + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
        this.dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === this.index);
          dot.setAttribute('aria-current', String(i === this.index));
        });
        this.syncVideos();
        if (manual) { this.pause(); this.resume(); }
      }

      syncVideos() {
        this.slides.forEach((slide, i) => {
          slide.querySelectorAll('video').forEach((video) => {
            if (i === this.index && this.visible && !document.hidden && video.getClientRects().length) {
              const playback = video.play();
              if (playback?.catch) playback.catch(() => {});
            } else video.pause();
          });
        });
      }

      pause() { clearInterval(this.timer); this.timer = null; }

      resume() {
        this.pause();
        if (this.slides.length < 2 || this.dataset.autoplay !== 'true' || this.dataset.editor === 'true' || !this.visible || document.hidden || this.matches(':focus-within') || (this.dataset.pauseHover === 'true' && this.matches(':hover')) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.timer = setInterval(() => {
          if (this.dataset.loop === 'false' && this.index === this.slides.length - 1) { this.pause(); return; }
          this.show(this.index + 1);
        }, Math.max(3000, Number(this.dataset.interval) || 6000));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
